import { ref, Ref } from 'vue';

const pageTitle: Ref<string> = ref('Your Default Title');

export function setPageTitle(title: string): void {
  pageTitle.value = title;
}

export default pageTitle;
